import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const bannerPic = content?.thumbnails?.image?.[0]?.url ? content.thumbnails.image[0].url : '';

        return bannerPic ? <div className={styles.banner} style={{ backgroundImage: `url(${bannerPic})` }} /> : null;
    }
}

export default errorBoundary(Banner);
